export const generateRecursiveList = (json = [], loadUsers) => {
  let treeData = [];
  if (json) {
    json.map((res, index) => {
      if (Array.isArray(res.children) && res.children.length > 0) {
        treeData.push({
          title: res.name,
          name: res.name,
          key: res.id,
          parent_id: res.parent_company_id,
          checkable: loadUsers ? false : undefined,
          children: generateRecursiveList(res.children, loadUsers)
        });
      } else {
        treeData.push({
          title: res.name,
          name: res.name,
          key: res.id,
          parent_id: res.parent_company_id,
          checkable: loadUsers ? false : undefined,
          isLeaf: loadUsers ? false : true // means the last layer
        });
      }
      return treeData;
    });
  }

  return treeData;
};
